// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1_YSn","buttons":"Footer_buttons__3QKO8"};